import { VectorVision } from '@/assets';
import { Add } from 'iconsax-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionVision = () => {
  const { t } = useTranslation();
  return (
    <div className="section-vision">
      <div className="title-section">
        <p className="title">{t('Vision')}</p>
        <span className="tag">(01)</span>
      </div>
      <div className="desc">
        {t(
          'We explore possibilities for businesses by transcending technology. Warppipe helps solve complex issues, adopt innovative models, and enhance competitiveness through advanced technology. We see a future where technology drives business value beyond a tool.'
        )}
      </div>
      <div className="list-icon-add">
        <Add color="#98a2b3" />
        <Add color="#98a2b3" />
        <Add color="#98a2b3" />
        <Add color="#98a2b3" />
        <Add color="#98a2b3" />
      </div>
      <div className="vector">
        <VectorVision />
      </div>
    </div>
  );
};

export default React.memo(SectionVision);
